import {
	AcceptanceStatus,
	DocumentWorkflowInstanceSignatureStatus,
	SubjectAction,
} from '@dealstack/shared/lib/generated';

export interface FormPair {
	templateId: string;
	instanceId: string;
	name: string;
	instruction: string | null;
	templateFileId: string;
	fileId: string | null;
	fileName: string | null;
	status: AcceptanceStatus | null;
	isInherited: boolean;
	subjectAction: SubjectAction | null;
	rejectionComment: string | null;
	createdAt: string;
	requiresSignature: boolean;
	signatureStatus: DocumentWorkflowInstanceSignatureStatus | null;
	signatureId: string | null;
}

export const hasSubmission = (form: FormPair): boolean => form.status !== null;
